/* cart/retrieveFormData
 ========================================================================== */

import isMobileDisplay from '../mobile/check';

export default function retrieveFormData(form, removeCustomisation = false) {
  const formData = new FormData(form);
  const isMobile = isMobileDisplay();

  const specificKey = `ean[${isMobile ? 'mobile' : 'desktop'}][]`;
  const specificEans = formData.getAll(specificKey);

  if (specificEans.length > 0) {
    specificEans.forEach(ean => {
        if (ean) formData.append('ean[]', ean);
    });
    formData.delete('ean[desktop][]');
    formData.delete('ean[mobile][]');
  }

  const finalEans = formData.getAll('ean[]');
  if (finalEans.length === 0 || finalEans.every(ean => !ean)) {
    return null;
  }

  if (removeCustomisation) {
    formData.delete('customizations[]');
  }

  return formData;
}